<template>
  <div class="desc">
    <template v-if="canEdit">
      <template v-if="editingDescription">
        <textarea
          v-model="local.description"
          class="ta"
          placeholder="Short description (max 240 chars)"
          rows="3"
          maxlength="240"
          @input="$emit('desc-input')"
          @blur="$emit('stop')"
        ></textarea>
      </template>

      <template v-else>
        <div class="ro" @click="$emit('start')">
          <span v-if="local.description" class="txt clipped">{{ local.description }}</span>
          <span v-else class="ph">Add description…</span>
        </div>
      </template>
    </template>

    <template v-else>
      <span class="txt clipped">
        {{ entity?.description || entity?.twitter || 'No description' }}
      </span>
    </template>
  </div>
</template>

<script setup>
defineProps({
  entity: { type: Object, default: null },
  local: { type: Object, required: true },
  canEdit: { type: Boolean, default: false },
  editingDescription: { type: Boolean, default: false },
})

defineEmits(['start', 'stop', 'desc-input'])
</script>

<style scoped>
.desc{ font-size:14px; color:#9ca3af; word-break:break-word; }
.ro{ cursor:text; }

.txt{
  font-size:14px;
  color:#e5e7eb;
  white-space:pre-wrap;
  word-break:break-word;
}
.clipped{
  display:-webkit-box;
  -webkit-line-clamp:3;
  -webkit-box-orient:vertical;
  overflow:hidden;
}

.ph{ font-size:14px; color:#4b5563; font-style:italic; }

.ta{
  width:100%;
  resize:none;
  min-height:72px;
  max-height:72px;
  background:#020617;
  border:1px solid #374151;
  border-radius:6px;
  padding:6px 8px;
  font-size:13px;
  color:#e5e7eb;
  line-height:1.4;
  overflow-y:auto;
}
.ta:focus{ outline:none; border-color:#6366f1; }

@media (max-width: 640px) {
  .txt{
    font-size:13px;
    overflow-wrap:anywhere;
    word-break:break-word;
  }
}
</style>
